import {
  Grid,
  GridItem,
  PrimaryButton,
  SectionMessage,
  TextInputField,
} from "@certn/cascadia-react";
import { APIError } from "@certn/legacy-api";
import { Field, Form, Formik, FormikValues } from "formik";
import qs from "qs";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";

import { usePassCodeCreate } from "./passcodeHooks";

export function PassCodeForm() {
  const { t } = useTranslation();

  const submit = usePassCodeCreate();

  const schema = object({
    email: string()
      .email(t<string>("Please provide a valid email address."))
      .required(t<string>("Please provide a valid email address.")),
  });

  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const emailParam =
    typeof queryParams.email === "string"
      ? queryParams.email.replace(" ", "+")
      : undefined;

  const redirectHandled = useRef(false);

  useEffect(() => {
    if (emailParam && !redirectHandled.current) {
      redirectHandled.current = true;
      submit(emailParam);
    }
  }, [emailParam]);

  return (
    <Formik
      initialValues={{
        email: emailParam || "",
      }}
      onSubmit={async (values: FormikValues, helpers) => {
        helpers.setStatus();
        try {
          await submit(values.email);
        } catch (e) {
          if (e instanceof APIError) {
            helpers.setStatus(e.detail);
            helpers.setErrors(e.errors);
          } else {
            helpers.setStatus(String(e));
          }
        }
      }}
      validationSchema={schema}
    >
      {({ status, isSubmitting }) => {
        return (
          <Form>
            <Grid>
              {status && (
                <GridItem>
                  <SectionMessage
                    type="danger"
                    sectionTitle={t("System Error")}
                    icon="info"
                  >
                    {status}
                  </SectionMessage>
                </GridItem>
              )}
              <GridItem>
                <Field
                  as={TextInputField}
                  isRequired
                  autoComplete="email"
                  label={t("Email")}
                  name="email"
                  placeholder={t("Your email address")}
                  type="email"
                  testID="welcome-screen-email-address-input"
                />
              </GridItem>
              <GridItem>
                <PrimaryButton
                  fullWidth
                  type="submit"
                  size="large"
                  isLoading={isSubmitting}
                  testID="welcome-screen-continue-button"
                >
                  {t("Continue")}
                </PrimaryButton>
              </GridItem>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
}
